import {Color, FmlxIcon} from 'fmlx-common-ui';
import PropTypes from 'prop-types';

function ProtocolExplorerFavoriteIndicator({greyedOut}) {
  return <FmlxIcon name="StartFilled" size="xs" customColor={greyedOut ? Color.NEUTRAL_9 : 'black'} />;
}

ProtocolExplorerFavoriteIndicator.propTypes = {
  greyedOut: PropTypes.bool,
};

ProtocolExplorerFavoriteIndicator.defaultProps = {
  greyedOut: false,
};

export default ProtocolExplorerFavoriteIndicator;
